// Cookie consent utility functions
import { logger } from './logger';
export const COOKIE_KEY = "wavescoop_cookie_consent";
export const POLICY_VERSION = "2024-01-15"; // Update this when cookie policy changes

// Interface for cookie consent data structure
export interface CookieConsent {
  version: string;
  timestamp: number;
  acceptedAnalytics: boolean;
}

/**
 * Get the user's current cookie consent preferences
 * @returns CookieConsent object or null if no consent stored
 */
export function getCookieConsent(): CookieConsent | null {
  try {
    const consentJson = localStorage.getItem(COOKIE_KEY);
    return consentJson ? JSON.parse(consentJson) : null;
  } catch (e) {
    logger.error("Error parsing cookie consent:", e);
    return null;
  }
}

/**
 * Check if user has accepted analytics cookies
 * @returns boolean indicating if analytics are allowed
 */
export function hasAnalyticsConsent(): boolean {
  const consent = getCookieConsent();
  return !!consent?.acceptedAnalytics && consent.version === POLICY_VERSION;
}

/**
 * Check if cookie consent needs to be shown (no consent or outdated version)
 * @returns boolean indicating if banner should be shown
 */
export function shouldShowCookieBanner(): boolean {
  const consent = getCookieConsent();
  return !consent || consent.version !== POLICY_VERSION;
} 